import { render, staticRenderFns } from "./sc-button.vue?vue&type=template&id=320b9ccb&scoped=true&"
import script from "./sc-button.vue?vue&type=script&lang=js&"
export * from "./sc-button.vue?vue&type=script&lang=js&"
import style0 from "./sc-button.vue?vue&type=style&index=0&id=320b9ccb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b9ccb",
  null
  
)

export default component.exports